import http from '../http'

export default {
	getFiles: () => {
		return http.get('/grn_record')
	},
	getFilesWithPagination: (payload) => {
		return http.get('/grn_record?page=' + payload.page + '&size=' + payload.size + '&paginate=Y')
	},
  getDirectSaleFilesWithPagination: (payload) => {
    return http.get('/grn_record/direct?page=' + payload.page + '&size=' + payload.size + '&paginate=Y')
  },
	uploadFile: (formData) => {
		return http.post('/grn_record', formData)
	},
	approveFile: (record) => {
		return http.post('/grn_record/approve', record)
	},
	deleteFile: (record) => {
		return http.post('/grn_record/delete-grnFile', record)
	},
	rejectFile: (record) => {
		return http.post('/grn_record/reject', record)
	},
	viewFile: (fileId) => {
		return http.get(`/grn_record/view/${fileId}`)
	},
	viewDeletedFile: (fileId) => {
		return http.get(`/grn_record/deleted/${fileId}`)
	},
	download: (fileId) => {
		return http.get(`/grn_record/download/${fileId}`, { responseType: 'blob' })
	},
	warehouseApproveRecords: (records) => {
		return http.post('/grn_record/approve_record', records)
	},

	warehouseApproveRecords2: (records) => {
		return http.post('/grn_record/approve_records', records)
		// return http.post('/grn_record/process', records)
	},
	sweepingsApproveRecords: (records) => {
		return http.post('/upload/sweepings/approve_record', records)
	},
	millerApproveRecord: (record) => {
		return http.post('/grn_record/confirm/approve', record)
	},
	editRecord: (record) => {
		return http.post('/grn_record/edit', record)
	},
	getRecordsPendingApproval: () => {
		return http.get('/grn_record/records_pending_approval')
	}
}
